<template>
  <div class="form-group"  style="min-width:50%;">
    <!-- <label for="exampleFormControlSelect1" :style="{fontFamily: value + ', sans-serif'}" >{{ value }}</label> -->
    <v-select
      v-bind="$attrs"
      @input="$emit('input', $event)"
      v-bind:value="value"
      label="label"
      placeholder="Select a font-family"
      :options="fontsOptions"
    >
      <template #option="{ label, value }">
        <span :style="{ fontFamily: value }">{{ label }} </span>
      </template>
    </v-select>
    <!-- <select
      v-bind="$attrs"
      @change="$emit('input', $event.target.value)"
      v-bind:value="value"
      class="form-control"
      id="exampleFormControlSelect1"
      :style="{fontFamily: value}"
    >
      <option>Please select</option>
      <option v-for="item in fonts" :key="item" :value="item">
        <span for="exampleFormControlSelect1" :style="{fontFamily: getFontFamily(item)}" >{{item}}</span>
      </option>
    </select> -->
  </div>
</template>

<script>
import fonts from "../assets/fonts.js";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "FontFamily",
  inheritAttrs: false,
  props: {
    label: String,
    name: String,
    value: [String, Boolean, Array, Object, Number],
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fonts: fonts,
      fontsOptions: fonts.map((el) => ({ value: el, label: el })),
    };
  },
  methods: {
    getFontFamily(f) {
      return f.includes('"') ? f.replace(/"/, "") : f;
    },
  },
  components: { vSelect },
};
</script>

<style>
</style>